import React from 'react'
import PasswordInput from 'ui/PasswordInput'
import { TypographyPrimary16Bold } from 'ui/typography/TypographyPrimary16Bold'

type PasswordBlockProps = {
	newPassword: string
	setNewPassword: (value: string) => void
}

const PasswordBlock: React.FC<PasswordBlockProps> = ({
	newPassword,
	setNewPassword,
}) => (
	<>
		<TypographyPrimary16Bold>Пароль</TypographyPrimary16Bold>
		<PasswordInput
			id={'newPassword'}
			setNewPassword={setNewPassword}
			newPassword={newPassword}
			width={'100%'}
			label={'Придумайте пароль'}
			needTooltip
		/>
	</>
)

export default PasswordBlock
